__turbopack_context__.v({
  "body": "learn-hero-module__AQ21sa__body",
  "breathe": "learn-hero-module__AQ21sa__breathe",
  "caption": "learn-hero-module__AQ21sa__caption",
  "chart": "learn-hero-module__AQ21sa__chart",
  "chartArea": "learn-hero-module__AQ21sa__chartArea",
  "core": "learn-hero-module__AQ21sa__core",
  "draw": "learn-hero-module__AQ21sa__draw",
  "eyebrow": "learn-hero-module__AQ21sa__eyebrow",
  "fade": "learn-hero-module__AQ21sa__fade",
  "fieldStar": "learn-hero-module__AQ21sa__fieldStar",
  "focusRing": "learn-hero-module__AQ21sa__focusRing",
  "glow": "learn-hero-module__AQ21sa__glow",
  "hair": "learn-hero-module__AQ21sa__hair",
  "idle": "learn-hero-module__AQ21sa__idle",
  "inset": "learn-hero-module__AQ21sa__inset",
  "layout": "learn-hero-module__AQ21sa__layout",
  "learn-breathe": "learn-hero-module__AQ21sa__learn-breathe",
  "learn-draw": "learn-hero-module__AQ21sa__learn-draw",
  "learn-fade": "learn-hero-module__AQ21sa__learn-fade",
  "learn-light": "learn-hero-module__AQ21sa__learn-light",
  "learn-pulse": "learn-hero-module__AQ21sa__learn-pulse",
  "learn-rise": "learn-hero-module__AQ21sa__learn-rise",
  "mono": "learn-hero-module__AQ21sa__mono",
  "name": "learn-hero-module__AQ21sa__name",
  "playing": "learn-hero-module__AQ21sa__playing",
  "rise": "learn-hero-module__AQ21sa__rise",
  "serif": "learn-hero-module__AQ21sa__serif",
  "small": "learn-hero-module__AQ21sa__small",
  "stage": "learn-hero-module__AQ21sa__stage",
  "star": "learn-hero-module__AQ21sa__star",
  "still": "learn-hero-module__AQ21sa__still",
  "story": "learn-hero-module__AQ21sa__story",
  "storyLabel": "learn-hero-module__AQ21sa__storyLabel",
  "text": "learn-hero-module__AQ21sa__text",
  "title": "learn-hero-module__AQ21sa__title",
});
